(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('ItensEstoqueEditCtrl', ItensEstoqueEditController);

  ItensEstoqueEditController.$inject = [
    '$scope',
    'ItensEstoqueService',
    'MessagesService',
    'LoadingService',
    'ProdutoModalService',
    'CommonHTTPService'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function ItensEstoqueEditController($scope, ItensEstoqueService, MessagesService,
    LoadingService, ProdutoModalService, CommonHTTPService) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.products = []; // vem da diretiva
    vm.groups = []; // vem da diretiva
    vm.units = []; // vem da diretiva
    vm.item = null; // vem da diretiva
    vm.editItem = {
      descricao: '',
      grupo: null,
      produto: null,
      unidade: null,
      atividade: null,
      possui_tratamento: false,
      id: null,
      produto_origem: null,
      carencia_residual_dias: null
    };
    vm.loading = false;
    vm.itensEstoque = null;
    vm.searchItensTerm = '';
    vm.loadingItensEstoque = false;

    //////////////////////////////////////////
    // Bindable methods
    vm.cancel = cancel;
    vm.saveItem = saveItem;
    vm.deleteItem = deleteItem;
    vm.openItensEstoqueModal = openItensEstoqueModal;
    vm.searchItensEstoque = searchItensEstoque;
    vm.isShowing = isShowing;

    //////////////////////////////////////////
    // Function declarations
    function getBasicData() {
      vm.editItem.descricao = vm.item.descricao;
      vm.editItem.produto = vm.item.produto;
      vm.editItem.unidade = _.find(vm.units, { id: +vm.item.unidade.id });
      vm.editItem.grupo = _.find(vm.groups, { id: vm.item.grupo.id });
      if (vm.item.atividade) {
        vm.editItem.atividade = _.find(vm.atividades, { id: vm.item.atividade.id });
      }
      vm.editItem.id = vm.item.item_id;
      vm.editItem.possui_tratamento = vm.item.possui_tratamento;
      vm.editItem.semente = !!vm.item.cd_produto;
      vm.editItem.carencia_residual_dias = vm.item.carencia_residual_dias;

      if (vm.editItem.possui_tratamento && vm.item.codigo_semente_origem) {
        vm.loadingItensEstoque = true;
        ItensEstoqueService.getItem(vm.item.codigo_semente_origem).then((item) => {
          vm.editItem.produto_origem = item;
        })
          .catch((error) => {
            MessagesService.alert('Não foi possível carregar a semente de origem');
            console.error(error);
          })
          .finally(() => vm.loadingItensEstoque = false);
      }
    }

    function isShowing() {
      const permissions = $scope.$root.permissions || {};
      return (permissions.itens_estoque || {}).canRead && !(permissions.itens_estoque || {}).canManage;
    }

    function cancel() {
      reset();
      if (!vm.item) {
        return $scope.$emit('cancelCreate');
      }
      $scope.$emit('cancelEdit', vm.item);
    }

    function reset() {
      if (!vm.item) {
        // Criando um novo item, então reseta os valores para quando for criar novamente
        for (const key in vm.editItem) {
          vm.editItem[key] = null;
        }
      } else {
        // Estava editando um item, volta os valores originais não alterados
        getBasicData();
      }
    }

    // TODO REVER
    // eslint-disable-next-line max-lines-per-function, max-params
    function saveItem(event) {
      if (event) {
        preventDefault(event);
      }

      vm.loading = true;
      return ItensEstoqueService.save(vm.editItem)
        .then(() => {
          if (vm.item) {
            return ItensEstoqueService.getItem(vm.item);
          }
          return null;
        })
        .then((result) => {
          reset();
          if (result) {
            MessagesService.alert('Item atualizado com sucesso!');
            return $scope.$emit('itemUpdated', vm.item, result);
          }
          MessagesService.alert('Item criado com sucesso!');
          $scope.$emit('itemCreated');
        })
        .catch((error) => {
          let message = 'Erro ao salvar item, tente novamente.';
          if (CommonHTTPService.isBadRequest(error.status) && error.data) {
            try {
              message = Object.values(error.data).join(',');
            } catch (e) {
              /* Do Nothing */
            }
          }
          console.error('Erro ao salvar item', error);
          MessagesService.alert(message);
        })
        .finally(() => vm.loading = false);
    }

    function deleteItem() {
      vm.loading = true;

      return MessagesService.confirm(`Você tem certeza que deseja apagar o item ${vm.item.descricao}?`)
        .then(() => ItensEstoqueService.deleteItem(vm.item))
        .then(() => {
          MessagesService.alert('Item apagado com sucesso!');
          $scope.$emit('itemCreated');
        });
    }

    function openItensEstoqueModal() {
      if (validateSelectedGroup()) {
        const filters = {
          grupo: vm.editItem.grupo
        };
        LoadingService.showLoading();
        ItensEstoqueService.load({ filters }, null).then((data) => {
          LoadingService.hideLoading();
          return ProdutoModalService.open(data.data || [], null, { allowMultiple: false });
        })
          .then((product) => {
            vm.editItem.produto_origem = product;
          })
          .catch(function(error) {
            if (error) {
              console.error('Erro ao buscar produtos', error);
              MessagesService.alert('Erro ao carregar produtos');
            }
          });
      }
    }

    function searchItensEstoque($select) {
      vm.searchItensTerm = $select.search;
      vm.itensEstoque = null;
      if (vm.searchItensTerm.length >= 3 && validateSelectedGroup()) {
        vm.loadingItensEstoque = true;
        const filters = {
          grupo: vm.editItem.grupo,
          descricao: $select.search
        };
        ItensEstoqueService.load({ filters }, null).then((data) => {
          vm.itensEstoque = data.data || [];
          vm.itensEstoque = _.remove(vm.itensEstoque, function(item) {
            return (item.item_id !== vm.editItem.id);
          });
        })
          .catch(function(error) {
            console.error('Erro ao buscar produtos', error);
            MessagesService.alert('Erro ao carregar produtos');
          })
          .finally(function() {
            vm.loadingItensEstoque = false;
          });
      }
    }

    function validateSelectedGroup() {
      if (!vm.editItem.grupo) {
        MessagesService.alert('Selecione um grupo de insumos');
        return false;
      }
      return true;
    }

    //////////////////////////////////////////
    // Controller logic
    const itemWatcher = $scope.$watch('edit.item', () => {
      itemWatcher();

      if (vm.item) {
        getBasicData();
      }
    });
  }
}());
